// Paleta compartida por los helpers V2 (usados hoy por RobinHood y Dashboard).
export const colors = {
  navy: '#004B8D',
  navyInk: '#003463',
  blue: '#0B65A5',
  paleBlue: '#EAF3FA',
  border: '#D9E3EC',
  text: '#1C2B38',
  muted: '#64748B',
  background: '#F3F6F9',
  surface: '#FFFFFF',
  surfaceAlt: '#F8FAFC',
  green: '#1E8E5A',
  greenBg: '#E7F5EE',
  amber: '#B8790C',
  amberBg: '#FCF1DC',
  red: '#C0392B',
  redBg: '#FBEAE8',
  purple: '#6B4FA0',
  purpleBg: '#F1ECF8',
  rightGroupEven: '#34495e',
  rightGroupOdd: '#4e6d8f',
}

// Tipografía fluida: escala el font-size entre una pantalla de notebook (~1366px)
// y una de monitor (~1920px) en vez de quedar fijo, para que los textos grandes
// no se vean desproporcionados según el ancho real disponible.
export const fluidFont = (maxPx, minPx = Math.round(maxPx * 0.82)) => {
  const minVw = 1366
  const maxVw = 1920
  const slope = (100 * (maxPx - minPx)) / (maxVw - minVw)
  const base = minPx - (slope * minVw) / 100
  return `clamp(${minPx}px, calc(${base.toFixed(2)}px + ${slope.toFixed(3)}vw), ${maxPx}px)`
}
